import { InputLabel } from 'ui/components/InputLabel/InputLabel'
import { styledInputLabel } from 'ui/components/InputLabel/styledInputLabel'

export const FlexInputLabel = styledInputLabel(InputLabel)({
  width: '100%',
})
